import FaqSection from "@/components/sections/products/shared/faq";
import { type FaqItem } from "@/components/sections/products/shared/faq/types";

const faqs: FaqItem[] = [
  {
    q: "Which proxy network should I pick?",
    a: "Pick mobile when you need the highest-trust premium pooled mobile IPs — great for market research, ad verification, and price monitoring. Pick residential for global, geo-targeted public-data collection across 195+ countries. ISP is best for long-lived sticky sessions, and datacenter is the cheapest option for bulk, high-volume data jobs.",
  },
  {
    q: "Can I mix networks on a single account?",
    a: "Yes. Your Proxidize dashboard supports all four networks side by side — buy a per-GB residential bundle and a per-proxy mobile plan at the same time, switch between them per workflow, and manage every plan from one place.",
  },
  {
    q: "Is there a free plan?",
    a: "We don't offer a traditional free tier, but every plan is backed by a 30-day money-back guarantee (conditional on using less than 10 GB of data). If a network doesn't perform as expected, contact support within 30 days for a full refund.",
  },
  {
    q: "When will ISP and Datacenter proxies launch?",
    a: "Both are in active build-out. Join the waiting list from the pricing card above to be notified the moment they go live — waitlist members also receive early-access launch pricing.",
  },
  {
    q: "Do you offer volume or enterprise discounts?",
    a: "Yes. Volume discounts on per-GB plans are applied automatically as bandwidth scales up. For enterprise needs — dedicated infrastructure, custom SLAs, or very high-volume pricing — contact our sales team for a tailored quote.",
  },
  {
    q: "What payment methods do you accept?",
    a: "All major credit and debit cards (Visa, Mastercard, Amex). All transactions are processed securely over SSL, and invoices are issued automatically for every purchase.",
  },
];

export default function PricingFaqSection() {
  return (
    <FaqSection
      faqs={faqs}
      description="Everything you need to know about pricing, networks, and what's coming next. Can't find what you're looking for?"
      headingId="pricing-faq-heading"
    />
  );
}
